import React from 'react'
import styled from 'styled-components'
import {
  borderRadiusSizes,
  iframeSection,
  margin,
  marginSizes
} from '@jarvis.oddle/core/theme/default'
import Card from '@jarvis.oddle/core/components/Card'
import breakpoint from 'src/utils/styledComponentsBreakpoint'
import Iframe from '@jarvis.oddle/core/components/Iframe'
import Modal, { CloseButton } from '@jarvis.oddle/core/components/Modal'
import useAppSelector from 'src/hooks/useAppSelector'
import { selectThankyou } from 'src/redux/thankyou'
import { makeControlledModal } from 'src/decorators/ModalController'

const StyledCardIframe = styled(Card).attrs(() => ({
  borderRadius: borderRadiusSizes.small,
  marginBottom: marginSizes.none
}))`
  width: 100%;
  height: 100%;
  align-self: start;
  ${breakpoint('desktop')`
    margin-bottom: ${margin[marginSizes.large]};
  `}
`

const StyledIframe = styled(Iframe).attrs(() => ({
  frameBorder: 0,
  width: '100%',
  height: '100%'
}))``

const StyledModalSection = styled(Modal.Section)`
  height: 90%;
  ${breakpoint('desktop')`
    height: ${iframeSection.desktop};
  `}
`

const DeliveryTrackingModal = React.memo(
  ({
    modal
  }: {
    modal: {
      show: boolean
      onClose: () => void
      onClosed: () => void
    }
  }): JSX.Element => {
    const thankyouState = useAppSelector(selectThankyou)

    const onClose = () => {
      modal.onClose()
    }

    const {
      trackingDeliveryResults: {
        data: { trackingLink }
      }
    } = thankyouState

    return (
      <Modal
        {...modal}
        withoutFocusTrap
        slideInAnimation='bottom'
      >
        <Modal.Container width={1100} height={500}>
          <Modal.Header>
            <CloseButton onClick={onClose} />
          </Modal.Header>
          <Modal.Body>
            <StyledModalSection>
              <StyledCardIframe>
                <StyledIframe src={trackingLink} />
              </StyledCardIframe>
            </StyledModalSection>
          </Modal.Body>
        </Modal.Container>
      </Modal>
    )
  }
)

export default makeControlledModal(
  DeliveryTrackingModal,
  'DeliveryTrackingModal'
)
